<script>
  export let close;
</script>

<div class="fixed top-0 left-0 w-full h-full bg-gray-700 bg-opacity-75 flex justify-center items-center z-50">
  <div class="relative bg-white rounded-lg w-3/4 h-3/4 overflow-y-scroll p-4">
    <h2 class="text-xl font-bold mb-4 mt-6">Privacy Policy for Playfully AI</h2>
            <p 
                class="absolute top-5 right-10 rounded-full text-base font-semibold leading-5 text-gray-800 hover:text-gray-400 cursor-default"
                on:click={close}
            >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </p>
    
    <h3 class="text-lg font-semibold mt-4">1. Introduction</h3>
    <p>Thank you for using Playfully AI. We respect your privacy and want to protect your personal information. This Privacy Policy explains how we collect, use, and disclose your information.</p>

    <h3 class="text-lg font-semibold mt-4">2. Information We Collect</h3>
    <ul class="list-disc pl-5">
      <li><strong>Automatic Information:</strong> We collect technical information automatically when you use our app, such as your IP address (anonymized), device type, and the dates and times of your requests.</li>
      <li><strong>User-Provided Information:</strong> Any data you provide within the app for role-playing or other interactions with the AI.</li>
    </ul>

    <h3 class="text-lg font-semibold mt-4">3. How We Use Your Information</h3>
    <ul class="list-disc pl-5">
      <li>To provide and improve our services.</li>
      <li>To analyze usage patterns and tailor features.</li>
      <li>To detect, prevent, or investigate security breaches or fraud.</li>
    </ul>

    <h3 class="text-lg font-semibold mt-4">4. Data Storage</h3>
    <p>We use Firebase Analytics to analyze user behavior within our app. Your data is stored securely on Firebase servers.</p>

    <h3 class="text-lg font-semibold mt-4">5. Sharing Your Information</h3>
    <p>We do not sell, trade, or rent your personal information to others. We may disclose information if required by law or in the case of protecting our rights, safety, or property, and/or complying with a judicial proceeding, court order, or legal process.</p>

    <h3 class="text-lg font-semibold mt-4">6. Age Limitations</h3>
    <p>The app is intended for use by individuals aged 18 and older. We do not knowingly collect or solicit information from individuals under the age of 18.</p>

    <h3 class="text-lg font-semibold mt-4">7. Your Rights</h3>
    <p>Depending on your jurisdiction, you may have the right to access, correct, delete, or restrict the use of your personal data. Please contact us if you wish to exercise these rights.</p>

    <h3 class="text-lg font-semibold mt-4">8. Changes to This Policy</h3>
    <p>We may update our Privacy Policy occasionally. Any changes will be posted on this page with an updated revision date.</p>

    <h3 class="text-lg font-semibold mt-4">9. Contact Us</h3>
    <p>For questions or concerns about our Privacy Policy or data practices, please contact us at hello@playfully.ai</p>

    <button on:click={close} class="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
      Close
    </button>
  </div>
</div>
